
export default {
  props: {
    list: {
      // label数据
      type: Array,
      default: () => []
    },
    index: {
      // 键值
      type: [Number, String],
      default: 0
    },
    ismore: {
      // 是否有可以展开的按钮
      type: Boolean,
      default: true
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      labelmore: false,
      selectshow: false,
      isUnfold: false
    }
  },
  computed: {
     isZh() {
      const code = this.$store.state.LanguageCode
      if (code == 'zh-cn' || code == 'zh-tw' || code == 'zh-hk' || code == 'zh') {
        return true
      } else {
        return false
      }
    }
   },
  mounted() {
    if (!this.ismore) return
      this.setele()
  },
  methods: {
    handleShow() {
      this.isUnfold = true
    },
    handleHide () {
      this.isUnfold = false
    },
    setele() {
      // 计算labei下拉
      const ele = document.getElementById(`trader-list-add${this.index}`)
      if (ele && ele.clientHeight > 22) this.selectshow = true
    }
  }
}
